import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdminTokenService {
  token: string | null = null;
}
